import { createAction } from '@reduxjs/toolkit';
import { normalizeError } from 'core/common/errors';
import { AppThunk } from 'core/common/store/types';
import { ContentOffer, OffersByCategory, OffersMap } from 'core/offers/entities';
import { mapOffersByCategoryToOffersMap } from '../../mappers';

export const fetchOffersPending = createAction('offers/FETCH_OFFERS/pending');
export const fetchOffersSucceed = createAction<OffersMap>('offers/FETCH_OFFERS/succeed');

export const fetchOffersFailed = createAction('offers/FETCH_OFFERS/failed');

export const fetchOffersByCategory =
  (offersByCategory: OffersByCategory, contentOffer?: ContentOffer): AppThunk =>
  async (dispatch, _, context) => {
    const { offersService, loggingService } = context;

    dispatch(fetchOffersPending());

    try {
      const offerIds = Object.values(offersByCategory).flatMap((offerId) => offerId);
      const offers = await offersService.getOffers(offerIds);

      const offersMapByCategory = mapOffersByCategoryToOffersMap(offers, offersByCategory);

      const offersMap = offersService.getOffersMap(offersMapByCategory, contentOffer);

      dispatch(fetchOffersSucceed({ ...offersMapByCategory, ...offersMap } as OffersMap));
    } catch (e) {
      const err = normalizeError(e);

      loggingService.error(err);
      dispatch(fetchOffersFailed());
    }
  };
